import React from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../mockData';

const FAQ = () => {
  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold">
              FAQ
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Domande Frequenti
          </h2>
          <p className="text-xl text-gray-600">
            Trova le risposte alle domande più comuni sui nostri servizi
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem 
              key={faq.id} 
              value={`item-${faq.id}`}
              className="bg-gray-50 rounded-xl border border-gray-200 px-6 hover:border-green-300 transition-colors"
            >
              <AccordionTrigger className="text-left hover:no-underline py-6">
                <span className="text-lg font-semibold text-slate-900 pr-4">
                  {faq.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Contact CTA */}
        <div className="mt-12 text-center bg-gradient-to-r from-green-50 to-gray-50 rounded-2xl p-8 border border-green-100">
          <p className="text-lg text-gray-700 mb-4">
            Non hai trovato la risposta che cercavi?
          </p>
          <p className="text-gray-600 mb-6">
            Il nostro team è a disposizione per rispondere a tutte le tue domande
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:337743730"
              className="inline-flex items-center justify-center bg-green-600 text-white px-8 py-4 rounded-lg hover:bg-green-700 transition-all hover:shadow-lg font-semibold text-lg"
            >
              <span className="mr-2">📱</span> Cellulare: 337743730
            </a>
            <a 
              href="tel:066240259"
              className="inline-flex items-center justify-center bg-green-600 text-white px-8 py-4 rounded-lg hover:bg-green-700 transition-all hover:shadow-lg font-semibold text-lg"
            >
              <span className="mr-2">☎️</span> Fisso: 066240259
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
